var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ca-row',[_c('ca-col',[_c('ca-box-information',{attrs:{"alert":_vm.recalculateMessage}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }